import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    settings: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu item label that opens the user/account settings page from the account avatar menu */
            settings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccountSettingsNavItem.settings?c=1iqhe34j351do", defaultMessage: "Settings" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
